angular.module('qkr').factory('menuService', function($http, appConfig, utils, imageService) {

    let currentMenuId = null;
    let menuList = [];
    let currentMenu = null;

    // TODO This entire service is a crazy mess. We should not be storing the state above. Refactor all of this.
	return {
        setCurrentMenuId: (id) => currentMenuId = id,
        getCurrentMenuId: () => currentMenuId,
        setCurrentMenu: (value) => currentMenu = value,
        getCurrentMenu: () => currentMenu,
        menuList,
        editingMenu: null,
        selectedMenu: null,

        menuViewReadonly: false,
        allowedCustomizeMenuItems: true,
        allowedCreateMenuItems: true,

        setSelectedMenuId(menuId) {
            currentMenuId = menuId;

            if (!utils.hasNoValue(menuList)) {
                currentMenu = utils.findItemInList(menuList, currentMenuId);
            }
        },
        loadMenu(menuId) {
            return $http.get(appConfig.apiUrl + 'productGroup/get/' + menuId, {withCredentials: true})
                .then((response) => response.data);
        },

        loadMenus(departmentId) {
            if (departmentId != null) {
                currentMenu = null;
                return $http.get(appConfig.apiUrl + 'department/' + departmentId + '/menus/', {withCredentials: true})
                    .then(response => {
                        menuList = response.data;
                        if (!utils.hasNoValue(menuList) && !utils.hasNoValue(currentMenuId)) {
                            currentMenu = utils.findItemInList(menuList, currentMenuId);
                        }
                        return response.data;        // Return the first element
                    });
            }
        },
        loadSharedMenus() {
            // FIXME this need a refactor, we cannot trust on the state of currentMenu, side effects
            return $http.get(appConfig.apiUrl + 'productGroup/listWithStats/', {withCredentials: true})
                        .then(response => {
                            menuList = [];
                            for (let i = 0; i < response.data.length; i++) {
                                menuList.push(response.data[i]);
                            } // TODO code below is brutal, cannot understand a thing.
                            if (!utils.hasNoValue(menuList) && !utils.hasNoValue(currentMenuId)) {
                                this.setCurrentMenu(utils.findItemInList(menuList, currentMenuId));
                            }
                            return response.data;
                        }, reason => reason);
        },

        loadProductCategoriesForMenu() {
            return $http.get(appConfig.apiUrl + 'productGroup/' + currentMenuId + '/productCategories',
                {withCredentials: true}).then((response) => response.data        // Return the first element
            );
        },

        loadMenuItems() {
            return $http.get(appConfig.apiUrl + 'productGroup/' + currentMenuId + '/menuItems', {withCredentials: true})
                .then(response => {
                    const menuItemList = response.data;
                    menuItemList.forEach(prod => {
                        prod.fullImageUrl = imageService.fullImageUrl(prod.imageUrl);
                    });
                    if (!utils.hasNoValue(currentMenu)) {
                          currentMenu.products = menuItemList; // TODO Is this being used? It looks like not...
                    }
                    return menuItemList;        // Return the first element
                });
        },

        getMenuItem(menuItemId) {
            return $http.get(appConfig.apiUrl + 'menuItem/' + menuItemId + '/get', {withCredentials: true})
                .then((response) => response.data,
                        (reason) => reason);
        },

        updateMenuItem(prod) {
        	const menuItemUpdateCommand = {};

        	menuItemUpdateCommand.menuItemId = prod.id;
        	menuItemUpdateCommand.shortDescription = prod.shortDescription;
        	menuItemUpdateCommand.longDescription = prod.longDescription;
        	menuItemUpdateCommand.amountMinorUnits = prod.amountMinorUnits;
            menuItemUpdateCommand.formTemplateId = prod.permissionFormId;

        	const variantUpdateCommandList = [];

        	angular.forEach(prod.variants, (variant) => {
        		const variantDefinitionCommand = {};
        		variantDefinitionCommand.variantId = variant.id;
        		variantDefinitionCommand.amountMinorUnits = variant.amountMinorUnits;
        		variantUpdateCommandList.push(variantDefinitionCommand);
        	});

        	menuItemUpdateCommand.variantUpdateCommands = variantUpdateCommandList;

        	if (prod.options.maxPerBeneficiary != null) {
        		menuItemUpdateCommand.maxPerBeneficiary = prod.options.maxPerBeneficiary;
            } else {
                menuItemUpdateCommand.maxPerBeneficiary = 0;
            }

            menuItemUpdateCommand.purchaseOnceType = prod.options.purchaseOnceType;

            if (prod.options.maxQuantity != null) {
            	menuItemUpdateCommand.maxQuantity = prod.options.maxQuantity;
            }

            menuItemUpdateCommand.availability = prod.availability;
            menuItemUpdateCommand.disabledOptionSets = prod.disabledOptionSets;

            menuItemUpdateCommand.posRef = prod.posRef;

            menuItemUpdateCommand.notificationUpdateCommand = prod.notificationUpdateCommand;

            return $http.post(appConfig.apiUrl + 'menuItem/update', menuItemUpdateCommand);
        },
        removeMenuItem(menuItem) {
        	const menuItemId = {id: menuItem.id};
            return $http.post(appConfig.apiUrl + 'menuItem/delete', menuItemId);
        },
        hideMenuItem(menuItem) {
            const menuItemId = {id: menuItem.id};
            return $http.post(appConfig.apiUrl + 'menuItem/hide', menuItemId);
        },
        unhideMenuItem(menuItem) {
            const menuItemId = {id: menuItem.id};
            return $http.post(appConfig.apiUrl + 'menuItem/unhide', menuItemId);
        },
        promoteMenuItem(menuItem) {
            const menuItemId = {id: menuItem.id};
            return $http.post(appConfig.apiUrl + 'menuItem/promote', menuItemId);
        },
        unpromoteMenuItem(menuItem) {
            const menuItemId = {id: menuItem.id};
            return $http.post(appConfig.apiUrl + 'menuItem/unpromote', menuItemId);
        },

        addMenuItems(menuItems, prodGroup) {
            const inventoryItemIdList = [];
            angular.forEach(menuItems, (menuItem) => {
            	const inventoryItemId = {id: menuItem.id};
            	inventoryItemIdList.push(inventoryItemId);
            });

            const addMenuItemCommand = {};
            addMenuItemCommand.menuId = prodGroup.id;
            addMenuItemCommand.inventoryItemIds = inventoryItemIdList;
            return $http.post(appConfig.apiUrl + 'menuItem/addMenuItems', addMenuItemCommand);
        },

        addMenuItemsAsHidden(menuItems, prodGroup) {
            const inventoryItemIdList = [];
            angular.forEach(menuItems, (menuItem) => {
                const inventoryItemId = {id: menuItem.id};
                inventoryItemIdList.push(inventoryItemId);
            });

            const addMenuItemCommand = {};
            addMenuItemCommand.menuId = prodGroup.id;
            addMenuItemCommand.inventoryItemIds = inventoryItemIdList;
            addMenuItemCommand.isHidden = true;
            return $http.post(appConfig.apiUrl + 'menuItem/addMenuItems', addMenuItemCommand);
        },

        updateMenu(form) {
            const availability = form.availability;
            const productCategoryIds = [];
            angular.forEach(form.productCategoryIds, (value) => {
               productCategoryIds.push({id: value});
            });

            // Strip out stuff we don't need to send to server (currently causes a problem on server but even when that
            // Is fixed we don't need to send merchant or products when updating menu)
            const updatedMenu = utils.withoutProperties(form, ['merchant', 'products']);

            const updateCommand = {availability, productCategories: productCategoryIds, prodGroup: updatedMenu};
            return $http.post(appConfig.apiUrl + 'productGroup/updateCommand', updateCommand);
        },
        createMenu(form) {
            const newMenu = angular.copy(form);
            const availability = newMenu.availability;

            newMenu.displayOpts = null;
            newMenu.availability = null;
            const productCategoryIds = [];
            angular.forEach(newMenu.productCategoryIds, (value) => {
                productCategoryIds.push({id: value});
            });
            const createCommand = {availability, productCategories: productCategoryIds, prodGroup: newMenu};
            return $http.post(appConfig.apiUrl + 'productGroup/createCommand', createCommand);
        },
        addMenuToDepartment(prodGroup, departmentId) {
            const dep = {id: departmentId};

            const createCommand = {
               prodGroup: utils.idOnly(prodGroup),
                department: utils.idOnly(dep)
            };
            return $http.post(appConfig.apiUrl + 'department/addMenu', createCommand);
        },
        updateMenuItemPosition(menuItem) {
            return $http.post(appConfig.apiUrl + 'menuItem/moveMenuItem', menuItem);
        },
        updateCategoryPosition(prodGroup, prodCategory, pos) {
            const updateCommand = {
                prodGroup: utils.idOnly(prodGroup),
                productCategory: utils.idOnly(prodCategory),
                newPosition: pos
            };
            return $http.post(appConfig.apiUrl + 'productGroup/moveProductCategory', updateCommand);
        },
        deleteMenu(prodGroup) {
            return $http.post(appConfig.apiUrl + 'productGroup/delete', utils.idOnly(prodGroup));
        },
        getMenus() {
            return $http.get(appConfig.apiUrl + 'productGroup/list', {withCredentials: true})
                .then((response) => response.data);
        },

        syncMenu(departmentId) {
            const updateCommand = {departmentId};
            const promise = $http.post(appConfig.apiUrl + 'productGroup/syncMenusForOutlet', updateCommand);
            return promise;
        },

        formHasSubmissions(form) {
            return $http.post(appConfig.apiUrl + 'menuItem/formHasSubmissions', form);
        },

        getOutletsUsingProdGroup(prodGroup) {
            return $http.get(appConfig.apiUrl + 'productGroup/' + prodGroup.id + '/listOutletsUsingProdGroup',
                {withCredentials: true}).then((response) => response.data);
        },

        getLatestItemAvailabilityForCategories(menuId, categories) {
            const data = {
                menuId,
                categoryNames: categories
            };
            const config = {
                params: data,
                headers: {Accept: 'application/json'}
            };
            return $http.get(appConfig.apiUrl + 'productGroup/getLatestItemAvailabilityForCategories/' + menuId, config)
                .then((response) => response.data);
        },

        getDateTime(hours, minutes, seconds) {
            const date = new Date();
            date.setHours(hours);
            date.setMinutes(minutes);
            date.setSeconds(seconds);
            return date;
        },

        getHours() {
            // Loads hours of day
            const hours = [];

            for (let i = 0; i <= 23; i++) {
                hours.push({name: utils.twoDecimalPlaces(i), value: i});
            }

            return hours;
        },

        getMinutes() {
            // Loads minutes
            const minutes = [];

            for (let i = 0; i <= 59; i++) {
                minutes.push({name: utils.twoDecimalPlaces(i), value: i});
            }

            return minutes;
        },

        getDaysOfWeek() {
            const daysOfWeek = utils.getDaysOfWeek();

            return daysOfWeek;
        },

        getDaysOfMonth() {
            // Loads days of month
            const daysOfMonth = [];

            for (let i = 1; i <= 31; i++) {
                daysOfMonth.push(i);
            }

            return daysOfMonth;
        },

        createShareMenuForPos(form) {
            const newMenu = angular.copy(form);
            const availability = newMenu.availability;

            newMenu.displayOpts = null;
            newMenu.availability = null;
            const productCategoryIds = [];
            angular.forEach(newMenu.productCategoryIds, (value) => {
                productCategoryIds.push({id: value});
            });
            const createCommand = {availability, productCategories: productCategoryIds, prodGroup: newMenu};
            return $http.post(appConfig.apiUrl + 'productGroup/createBlankMenuForPos', createCommand);
        }

    };
});




// WEBPACK FOOTER //
// ./src/services/menu.services.js